import React, { useState } from 'react';
import { Tool } from '../types/whiteboard';
import '../styles/Whiteboard.css';

// Using simple icon components to avoid TypeScript issues
const icons = {
  select: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z" /></svg>,
  sticky: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8l-5-5z" /></svg>,
  text: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="4 7 4 4 20 4 20 7" /><line x1="9" y1="20" x2="15" y2="20" /><line x1="12" y1="4" x2="12" y2="20" /></svg>,
  shapes: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 2 19 12 15 22 19 12 2" /></svg>,
  pen: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 19l7-7 3 3-7 7-3-3z" /><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" /><path d="M2 2l7.586 7.586" /><circle cx="11" cy="11" r="2" /></svg>,
  frames: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /></svg>,
  comment: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>,
  rectangle: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /></svg>,
  circle: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /></svg>,
  line: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12" /></svg>,
  arrow: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>,
  trash: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
  download: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>,
  color: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /></svg>,
  undo: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></svg>,
  redo: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></svg>,
  maximize: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 3 21 3 21 9" /><polyline points="9 21 3 21 3 15" /><line x1="21" y1="3" x2="14" y2="10" /><line x1="3" y1="21" x2="10" y2="14" /></svg>,
  zoomOut: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /><line x1="8" y1="11" x2="14" y2="11" /></svg>,
  zoomIn: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /><line x1="11" y1="8" x2="11" y2="14" /><line x1="8" y1="11" x2="14" y2="11" /></svg>,
  hand: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0" /><path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2" /><path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8" /><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2a8 8 0 0 1-8-8v-2a2 2 0 0 1 2-2h.5" /></svg>,
  triangle: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 22h20L12 2z" /></svg>,
  diamond: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2l10 10-10 10L2 12 12 2z" /></svg>,
  star: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>,
  hexagon: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /></svg>,
  ellipse: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><ellipse cx="12" cy="12" rx="10" ry="6" /></svg>,
  eraser: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 20H7L3 16 12 7 17 12M11 14L17 8" /></svg>,
};

interface WhiteboardToolbarProps {
  currentTool: Tool;
  currentColor: string;
  currentStrokeWidth: number;
  zoom: number;
  onToolChange: (tool: Tool) => void;
  onColorChange: (color: string) => void;
  onStrokeWidthChange: (width: number) => void;
  onZoomChange: (zoom: number) => void;
  onFitToScreen: () => void;
  onClear: () => void;
  onUndo: () => void;
  onRedo?: () => void;
  onExport: () => void;
}

const WhiteboardToolbar: React.FC<WhiteboardToolbarProps> = ({
  currentTool,
  currentColor,
  currentStrokeWidth,
  zoom,
  onToolChange,
  onColorChange,
  onStrokeWidthChange,
  onZoomChange,
  onFitToScreen,
  onClear,
  onUndo,
  onRedo,
  onExport,
}) => {
  const [showShapesMenu, setShowShapesMenu] = useState(false);

  const mainTools: { id: Tool | 'shapes' | 'frames' | 'comment' | 'pan'; icon: () => React.ReactElement; label: string }[] = [
    { id: 'select', icon: icons.select, label: 'Select' },
    { id: 'pan', icon: icons.hand, label: 'Pan / Move' },
    { id: 'sticky', icon: icons.sticky, label: 'Sticky Note' },
    { id: 'text', icon: icons.text, label: 'Text' },
    { id: 'shapes', icon: icons.shapes, label: 'Shapes' },
    { id: 'pen', icon: icons.pen, label: 'Pen' },
    { id: 'eraser', icon: icons.eraser, label: 'Eraser' },
    { id: 'frames', icon: icons.frames, label: 'Frames' },
    { id: 'comment', icon: icons.comment, label: 'Comment' },
  ];

  const shapeTools: { id: Tool; icon: () => React.ReactElement; label: string }[] = [
    { id: 'rectangle', icon: icons.rectangle, label: 'Rectangle' },
    { id: 'circle', icon: icons.circle, label: 'Circle' },
    { id: 'ellipse', icon: icons.ellipse, label: 'Ellipse' },
    { id: 'triangle', icon: icons.triangle, label: 'Triangle' },
    { id: 'diamond', icon: icons.diamond, label: 'Diamond' },
    { id: 'star', icon: icons.star, label: 'Star' },
    { id: 'hexagon', icon: icons.hexagon, label: 'Hexagon' },
    { id: 'line', icon: icons.line, label: 'Line' },
    { id: 'arrow', icon: icons.arrow, label: 'Arrow' },
  ];

  const handleToolClick = (toolId: string) => {
    if (toolId === 'shapes') {
      setShowShapesMenu(!showShapesMenu);
    } else if (toolId === 'frames') {
      onToolChange('frame' as Tool);
      setShowShapesMenu(false);
    } else if (toolId === 'comment') {
      onToolChange('comment' as Tool);
      setShowShapesMenu(false);
    } else if (toolId === 'pan') {
      onToolChange('pan' as Tool);
      setShowShapesMenu(false);
    } else {
      onToolChange(toolId as Tool);
      setShowShapesMenu(false);
    }
  };

  return (
    <>
      {/* Left Vertical Toolbar */}
      <div className="whiteboard-toolbar-vertical">
        {mainTools.map((tool) => {
          const Icon = tool.icon;
          return (
            <button
              key={tool.id}
              className={`tool-button-icon ${tool.id === 'shapes'
                  ? (['rectangle', 'circle', 'ellipse', 'triangle', 'diamond', 'star', 'hexagon', 'line', 'arrow'].includes(currentTool) ? 'active' : '')
                  : (currentTool === tool.id ? 'active' : '')
                }`}
              onClick={() => handleToolClick(tool.id)}
              title={tool.label}
            >
              <Icon />
            </button>
          );
        })}

        {/* Shapes submenu popup */}
        {showShapesMenu && (
          <div className="shapes-menu-popup">
            {shapeTools.map((shape) => {
              const ShapeIcon = shape.icon;
              return (
                <button
                  key={shape.id}
                  className={`menu-item ${currentTool === shape.id ? 'active' : ''}`}
                  onClick={() => {
                    onToolChange(shape.id);
                    setShowShapesMenu(false);
                  }}
                >
                  <span className="menu-icon">
                    <ShapeIcon />
                  </span>
                  {shape.label}
                </button>
              );
            })}
          </div>
        )}

        <div className="toolbar-divider"></div>

        {/* Clear All button */}
        <button
          className="tool-button-icon"
          onClick={onClear}
          title="Clear All"
        >
          {icons.trash()}
        </button>

        {/* Export PNG button */}
        <button
          className="tool-button-icon"
          onClick={onExport}
          title="Export PNG"
        >
          {icons.download()}
        </button>
      </div>

      {/* Bottom Controls Bar */}
      <div className="whiteboard-bottom-controls">
        <div className="bottom-controls-left">
          <button
            className="control-button"
            onClick={onUndo}
            title="Undo"
          >
            {icons.undo()}
          </button>
          {onRedo && (
            <button
              className="control-button"
              onClick={onRedo}
              title="Redo"
            >
              {icons.redo()}
            </button>
          )}
        </div>

        <div className="bottom-controls-right">
          <button
            className="control-button"
            onClick={() => onZoomChange(Math.max(0.1, zoom - 0.1))}
            title="Zoom out"
          >
            {icons.zoomOut()}
          </button>
          <button
            className="control-button"
            onClick={() => onZoomChange(Math.min(3, zoom + 0.1))}
            title="Zoom in"
          >
            {icons.zoomIn()}
          </button>
        </div>
      </div>
    </>
  );
};

export default WhiteboardToolbar;
